import { Exclude, Transform, Type } from 'class-transformer';

import { booleanTransform, centTransform, dateTransform } from '../utils/helper';
import { Contatto } from './contatto.model';
import { InsModDate } from './date.model';
import { Offer, OfferPayMode } from './offer.model';
import { User } from './user.model';

export class Campaign extends InsModDate {
	id!: number;
	hqid?: number;
	createdby?: number;
	@Transform(dateTransform)
	startdate?: Date;
	@Transform(dateTransform)
	stopdate?: Date;
	title?: string;
	description?: string;
	script?: string;
	status?: CampaignStatus;
	@Transform(booleanTransform)
	excluderecall?: boolean;
	@Transform(booleanTransform)
	enableportfolio?: boolean;
	@Transform(booleanTransform)
	enabledormient?: boolean;
	@Transform(booleanTransform)
	enablenew?: boolean;
	maxrecall!: number;

	@Exclude({ toPlainOnly: true })
	@Type(() => User)
	creator?: User;

	get isActive(): boolean {
		return this.status === CampaignStatus.ACTIVE;
	}
}

export class Campaignthresholds extends InsModDate {
	id!: number;
	campaignid!: number;
	@Transform(centTransform)
	minamount?: number;
	@Transform(centTransform)
	maxamount?: number;
	@Transform(booleanTransform)
	enabled?: boolean = false;
}

export class CampaignContact extends InsModDate {
	id!: number;
	campaignid!: number;
	contactid!: number;
	status!: string;
	@Transform(dateTransform)
	assigndate?: Date;
	operatorid?: number;
	@Transform(dateTransform)
	nextrecall?: Date;
	category?: string;
	@Transform(centTransform)
	amount?: number;
	paymode?: string;
	note?: string;
	email?: string;
	@Transform(dateTransform)
	lastcalldate?: Date;
	@Transform(booleanTransform)
	emptybollettino?: boolean;

	@Exclude({ toClassOnly: true })
	address?: string;
	@Exclude({ toClassOnly: true })
	city?: string;
	@Exclude({ toClassOnly: true })
	zipcode?: string;
	@Exclude({ toClassOnly: true })
	mobile?: string;
	@Exclude({ toClassOnly: true })
	landline?: string;
	@Exclude({ toClassOnly: true })
	province?: string;
	@Exclude({ toClassOnly: true })
	comune?: string;
	@Exclude({ toClassOnly: true })
	streetno?: string;
	@Exclude({ toClassOnly: true })
	@Transform(booleanTransform)
	quotaassociativa?: boolean;

	@Type(() => Contatto)
	@Exclude({ toPlainOnly: true })
	contact!: Contatto;
	@Type(() => User)
	@Exclude({ toPlainOnly: true })
	operator?: User;
	@Type(() => CampaignCall)
	@Exclude({ toPlainOnly: true })
	calls?: CampaignCall[];

	@Type(() => Offer)
	@Exclude({ toPlainOnly: true })
	ultimaOfferta?: Offer;

	@Exclude({ toPlainOnly: true })
	offerid?: number;

	get isStatusQueue(): boolean {
		return this.status === CampaignContactStatus.QUEUE;
	}

	get isStatusRecall(): boolean {
		return this.status === CampaignContactStatus.RECALL;
	}

	get isStatusNoAnswer(): boolean {
		return this.status === CampaignContactStatus.NO_ANSWER;
	}

	get isPayModeBank(): boolean {
		return this.paymode === OfferPayMode.PAYMENT_METHOD_BANKTRANSFER;
	}

	get isPayModeSede(): boolean {
		return this.paymode === OfferPayMode.PAYMENT_METHOD_SEDE;
	}

	get isPayModeBollettino(): boolean {
		return this.paymode === OfferPayMode.PAYMENT_METHOD_BOLLETTINO;
	}
}

export class CampaignLinkResponse {
	linked?: number;
	request?: any;
}

export class CampaignOperator extends InsModDate {
	id!: number;
	campaignid!: number;
	operatorid!: number;

	@Type(() => User)
	@Exclude({ toPlainOnly: true })
	operatore?: User;
}

export class CampaignCall extends InsModDate {
	id!: number;
	linkid!: number;
	contactid!: number;
	campaignid!: number;
	operatorid!: number;
	@Transform(dateTransform)
	calldate!: Date;
	status!: string;
	note?: string;

	@Type(() => Contatto)
	@Exclude({ toPlainOnly: true })
	contact?: Contatto;

	@Type(() => Campaign)
	@Exclude({ toPlainOnly: true })
	campaign?: Campaign;
}

export class CampaignTopStats {
	chiave?: string;
	valore?: any;
}

export enum CampaignStatus {
	ACTIVE = 'active',
	DISABLED = 'disabled',
	LOCKED = 'locked'
}

export enum CampaignContactStatus {
	QUEUE = 'queue',
	RECALL = 'recall',
	NO_ANSWER = 'noanswer',
	REJECTED = 'rejected',
	PENDINGCCP = 'pendingccp',
	PENDINGBANK = 'pendingbank',
	ACCEPTED = 'accepted',
}

export enum CampaignCallStatus {
	REJECT = 'reject',
	RECALL = 'recall',
	ACCEPT = 'accept',
	NO_ANSWER = 'noanswer',
}